import { Box, RouterTabContent, RouterTabs, Typography, useHeader } from '@forgeglobal/design-framework'
import { LeadsDashboardTable } from 'components/leads/LeadsDashboardTable'

import { LeadFilters } from 'components/leads/LeadsDashboardFilter'
import { TodoItemStatusType, useAppDataQuery } from 'graphql/bindings/AdminBindings'
import { netWorth, targetCheckSize } from 'util/Enums'
import React, { Fragment } from 'react'
import moment from 'moment'

const defaultFilters: LeadFilters = {
  netWorth: netWorth.map(x => x.value),
  targetCheckSize: targetCheckSize.map(x => x.value),
  leadStatus: null,
}

// The inbox tab can be really noisy (as it includes all the signups
// flowing in from platform). Adding some default filters helps cut
// down the noise by hiding "low-value" accounts
const defaultInboxFilters: LeadFilters = {
  ...defaultFilters,
  netWorth: netWorth.slice(-3).map(x => x.value),
  targetCheckSize: targetCheckSize.slice(1).map(x => x.value),
  dateSignedUp: moment()
    .subtract(14, 'days')
    .toDate(),
  leadStatus: null,
}

const defaultLeadsFilters: LeadFilters = {
  ...defaultFilters,
  leadStatus: TodoItemStatusType.Live,
  profileAssignee: null,
}

const defaultDismissedFilters: LeadFilters = {
  ...defaultFilters,
  leadStatus: TodoItemStatusType.Dismissed,
}

export const InvestorLeads: React.FC = () => {
  useHeader()

  const { data } = useAppDataQuery()

  const defaultMyLeadsFilters: LeadFilters = {
    ...defaultFilters,
    leadStatus: TodoItemStatusType.Live,
    profileAssignee: data?.currentAdmin?.id,
  }

  return (
    <Fragment>
      <Box p={3} pt={4}>
        <Typography variant="h4" color="secondary" style={{ textTransform: 'none' }}>
          Leads
        </Typography>
      </Box>

      <RouterTabs>
        <RouterTabContent label="inbox">
          <LeadsDashboardTable title="Inbox" defaultFilters={defaultInboxFilters} />
        </RouterTabContent>
        <RouterTabContent label="Leads">
          <LeadsDashboardTable title="Leads" defaultFilters={defaultLeadsFilters} />
        </RouterTabContent>
        <RouterTabContent label="My Leads">
          <LeadsDashboardTable title="My Leads" defaultFilters={defaultMyLeadsFilters} />
        </RouterTabContent>
        <RouterTabContent label="Dismissed">
          <LeadsDashboardTable title="Dismissed" defaultFilters={defaultDismissedFilters} />
        </RouterTabContent>
      </RouterTabs>
    </Fragment>
  )
}
